/**
 * Onboarding Tracker Column Definitions
 * Organized by category: Phase, Personal, Job, Recruitment, Org, Benefits, Checklist, Other
 */

export const PHASE_STATUS_OPTIONS = [
  'New',
  'In Progress',
  'Completed'
];

export const ONBOARDING_COLUMNS = [
  // Phase Status
  {
    key: 'phase_status',
    label: 'Phase Status',
    type: 'select',
    options: PHASE_STATUS_OPTIONS,
    required: true,
    width: 140,
    category: 'phase'
  },

  // Personal Information
  {
    key: 'employee_name',
    label: 'Employee Name',
    type: 'text',
    required: true,
    width: 180,
    category: 'personal'
  },
  {
    key: 'personal_email',
    label: 'Personal Email',
    type: 'email',
    width: 200,
    category: 'personal'
  },
  {
    key: 'personal_phone',
    label: 'Personal Phone',
    type: 'tel',
    width: 140,
    category: 'personal'
  },
  {
    key: 'date_of_birth',
    label: 'Date of Birth',
    type: 'date',
    width: 130,
    category: 'personal'
  },
  {
    key: 'start_date',
    label: 'Start Date',
    type: 'date',
    width: 130,
    category: 'personal',
    validation: 'monday' // Must be Monday
  },

  // Job Information
  {
    key: 'job_title',
    label: 'Job Title',
    type: 'text',
    required: true,
    width: 180,
    category: 'job'
  },
  {
    key: 'department',
    label: 'Department',
    type: 'text',
    width: 150,
    category: 'job'
  },
  {
    key: 'sc_department',
    label: 'SC Department',
    type: 'text',
    width: 150,
    category: 'job'
  },
  {
    key: 'target_store',
    label: 'Target Store',
    type: 'text',
    width: 150,
    category: 'job'
  },
  {
    key: 'training_store',
    label: 'Training Store',
    type: 'text',
    width: 150,
    category: 'job'
  },

  // Recruitment Information
  {
    key: 'recruiter',
    label: 'Recruiter',
    type: 'text',
    width: 150,
    category: 'recruitment'
  },
  {
    key: 'hiring_manager',
    label: 'Hiring Manager',
    type: 'text',
    width: 150,
    category: 'recruitment'
  },

  // Organization Hierarchy (from flm_report - readonly)
  {
    key: 'flm_name',
    label: 'FLM Name',
    type: 'text',
    width: 150,
    category: 'org',
    readOnly: true
  },
  {
    key: 'hr_generalist',
    label: 'HR Generalist',
    type: 'text',
    width: 150,
    category: 'org',
    readOnly: true
  },
  {
    key: 'store_manager',
    label: 'Store Manager',
    type: 'text',
    width: 150,
    category: 'org',
    readOnly: true
  },
  {
    key: 'vp',
    label: 'VP',
    type: 'text',
    width: 150,
    category: 'org',
    readOnly: true
  },
  {
    key: 'director',
    label: 'Director',
    type: 'text',
    width: 150,
    category: 'org',
    readOnly: true
  },
  {
    key: 'mum',
    label: 'MUM',
    type: 'text',
    width: 150,
    category: 'org',
    readOnly: true
  },

  // Benefits & Equipment
  {
    key: 'allowances',
    label: 'Allowances',
    type: 'text',
    width: 150,
    category: 'benefits',
    placeholder: 'e.g., Car, Phone'
  },
  {
    key: 'equipment',
    label: 'Equipment',
    type: 'text',
    width: 150,
    category: 'benefits',
    placeholder: 'e.g., Laptop'
  },

  // Onboarding Checklist
  {
    key: 'background_check',
    label: 'Background Check',
    type: 'checkbox',
    width: 150,
    category: 'checklist'
  },
  {
    key: 'support_ticket',
    label: 'Support Ticket',
    type: 'checkbox',
    width: 130,
    category: 'checklist'
  },
  {
    key: 'new_hire_docs',
    label: 'New Hire Docs',
    type: 'checkbox',
    width: 140,
    category: 'checklist'
  },
  {
    key: 'welcome_email',
    label: 'Welcome Email',
    type: 'checkbox',
    width: 140,
    category: 'checklist'
  },

  // Other
  {
    key: 'notes',
    label: 'Notes',
    type: 'textarea',
    width: 250,
    category: 'other'
  }
];

// Helper function to get columns by category
export const getColumnsByCategory = (category) => {
  return ONBOARDING_COLUMNS.filter(col => col.category === category);
};

// Helper function to get all column keys
export const getAllColumnKeys = () => {
  return ONBOARDING_COLUMNS.map(col => col.key);
};

// Helper function to get editable columns (exclude readonly)
export const getEditableColumns = () => {
  return ONBOARDING_COLUMNS.filter(col => !col.readOnly);
};

// Helper function to get readonly columns
export const getReadonlyColumns = () => {
  return ONBOARDING_COLUMNS.filter(col => col.readOnly);
};
